import PlaidLink from '@/shared/plaid/PlaidLink'
import { PlaidItem } from '@/reducers/finances/plaidItemReducer'
import { getPlaidButtonLabel } from '../../../helpers'

import { Button, Text } from '@/ui'
import { TypographyStyles } from '@/styles'
import { InstitutionLogo } from './logo'
import { StatementPill, StatusPill } from './pills'

export const InstitutionHeader = ({
  institution,
  isInRolledOutInstitutions,
  isOnboarding = false,
  handleRemoveConnection,
}: {
  institution: PlaidItem
  isInRolledOutInstitutions: boolean
  isOnboarding: boolean
  handleRemoveConnection?: () => void
}) => {
  const { disconnectedOn, institutionName } = institution

  return (
    <div className="institutionHeader">
      <div>
        <div className="institutionLabel">
          <InstitutionLogo
            className="institutionLogo"
            institution={institution}
          />

          <div>
            <div className="nameLabel flex flex-row items-center">
              <Text variant={TypographyStyles.LABEL_MD}>{institutionName}</Text>
              <StatusPill active={!disconnectedOn} className="ml-2" />

              {!isOnboarding && (
                <StatementPill
                  accounts={institution.accounts}
                  className="ml-2"
                />
              )}
            </div>

            {disconnectedOn && (
              <Text variant={TypographyStyles.BODY_SM}>
                We have lost connection to this institution. Please reconnect it
                now.
              </Text>
            )}
          </div>
        </div>
      </div>

      {isOnboarding ? (
        <Button variant="link" onClick={handleRemoveConnection}>
          Remove Connection
        </Button>
      ) : (
        <PlaidLink
          buttonVariant={disconnectedOn ? undefined : 'link'}
          reconnectButtonText={getPlaidButtonLabel(
            institution,
            disconnectedOn,
            isInRolledOutInstitutions
          )}
          account={institution.accounts[0]}
          disconnected={Boolean(disconnectedOn)}
        />
      )}
    </div>
  )
}
